import client from "@irati/utils/services/apollo"
import {getGlobalTenant} from "@irati/region/services/globalTenant"
import region from "@irati/region/services/region"
import {setUserAccountCookie} from "@irati/utils/cookies/userAccountCookie"
import API from "@irati/utils/services/API"
import Auth from "../../types/Auth"
import resumeQuery from "../../services/queries/resumeV4"
import tokens from "../../services/tokens"
import AuthServiceAbstract from "./base"
import AuthStorage from "./storage"

class AuthStream extends AuthServiceAbstract<Auth> {
  private _hasRequestTokens = false

  start(auth: Auth) {
    return super.start(auth).then(() => {
      setUserAccountCookie()
    })
  }

  isValid(auth?: Auth) {
    return !!(auth && auth.user && auth.business && auth.productPermissions)
  }

  async init() {
    const data = await this.storage.get()
    let sessionId
    if (!this._hasRequestTokens) {
      this._hasRequestTokens = true
      sessionId = await tokens.resume()
    }

    if (sessionId && data && data.user) {
      return this.start({sessionId, ...data})
    }
  }

  refresh() {
    return API.forceTokenRefresh().then(() => {
      const userId = this.data?.user.uuid
      const businessId = this.data?.user.businessId || this.data?.user.tenant
      const variables = {userId, businessId, tenantId: businessId}
      return client.query({query: resumeQuery, variables, fetchPolicy: "network-only"})
    })
  }

  protected query(auth: Auth) {
    /** @todo: remove tenant + tenantId fall backs after release (safe after 15/8/2020) */
    const userId = auth.user.uuid
    const businessId = auth.user.businessId || auth.user.tenant
    const variables = {userId, businessId, tenantId: businessId}
    return async () => {
      if (auth && auth.business && auth.business.subdomain && !region.get()) {
        try {
          const regional = await getGlobalTenant(auth.business.subdomain)
          region.set(regional.region)
        } catch (e) {
          /* no-op */
        }
      }

      return client.watchQuery<Auth>({query: resumeQuery, variables, fetchPolicy: "network-only"})
    }
  }
}

const authStream = new AuthStream({storage: new AuthStorage("auth")})

export default authStream
